import { Rate } from "../rate-type";
import { RateLocationMapper } from "./rate-location.mapper";
import { RateLocationBase } from "./rate-location-base.model";
import { Location } from "../../location/location.model";
import { RateLocation } from "./rate-location.type";
import { LocationMapper } from "../../location/location.mapper";
import { RateMapper } from "../rate.mapper";

export class AirRateLocation extends RateLocationBase {
  constructor(
    protected id: number,
    protected discriminator: string,
    protected location: Location,
    protected comment: string,
    protected rate: Rate,
    protected minPrice: number,
    protected weightPriceLt45: number,
    protected weightPriceGt45: number,
    protected weightPriceGt100: number,
    protected weightPriceGt300: number,
    protected weightPriceGt500: number,
    protected weightPriceGt1000: number,
    protected parent: RateLocation,
    protected excludedOriginLocations: RateLocation[],
    protected excludedDestinationLocations: RateLocation[],
  ) {
    super(
      id,
      discriminator,
      location,
      comment,
      rate,
      parent,
      excludedOriginLocations,
      excludedDestinationLocations,
    );
  }

  public getMinPrice(): number {
    return this.minPrice;
  }

  public setMinPrice(param: number): void {
    this.minPrice = param;
  }

  public getWeightPriceLt45(): number {
    return this.weightPriceLt45;
  }
  public setWeightPriceLt45(param: number): void {
    this.weightPriceLt45 = param;
  }

  public getWeightPriceGt45(): number {
    return this.weightPriceGt45;
  }
  public setWeightPriceGt45(param: number): void {
    this.weightPriceGt45 = param;
  }

  public getWeightPriceGt100(): number {
    return this.weightPriceGt100;
  }
  public setWeightPriceGt100(param: number): void {
    this.weightPriceGt100 = param;
  }

  public getWeightPriceGt300(): number {
    return this.weightPriceGt300;
  }
  public setWeightPriceGt300(param: number): void {
    this.weightPriceGt300 = param;
  }

  public getWeightPriceGt500(): number {
    return this.weightPriceGt500;
  }
  public setWeightPriceGt500(param: number): void {
    this.weightPriceGt500 = param;
  }

  public getWeightPriceGt1000(): number {
    return this.weightPriceGt1000;
  }
  public setWeightPriceGt1000(param: number): void {
    this.weightPriceGt1000 = param;
  }

  public getClone(): RateLocation {
    return RateLocationMapper.map({
      id: this.getId(),
      discriminator: this.getDiscriminator(),
      location: LocationMapper.map(this.getLocation()),
      comment: this.getComment(),
      rate: RateMapper.map(this.getRate()),
      minPrice: this.getMinPrice(),
      weightPriceLt45: this.weightPriceLt45,
      weightPriceGt45: this.weightPriceGt45,
      weightPriceGt100: this.weightPriceGt100,
      weightPriceGt300: this.weightPriceGt300,
      weightPriceGt500: this.weightPriceGt500,
      weightPriceGt1000: this.weightPriceGt1000,
      parent: this.getParent(),
      excludedOriginLocations: this.getExcludedOriginLocations(),
      excludedDestinationLocations: this.getExcludedDestinationLocations(),
    });
  }
}
